import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {EventBusService} from "../../../core/services/event-bus.service";
import {ImporterService} from "../../../core/services/importer.service";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {tap} from "rxjs/operators";
import {DictionaryPosition} from "../../model/dictionary.model";
import {Observable} from "rxjs";
import {IEpu} from "../../model/interface/epu-import.interface";
import {Inject, Optional} from "@angular/core";

interface ImportEpuDialogData {
  costReport?: boolean;
}

@Component({
  selector: 'app-import-epu',
  templateUrl: './import-epu.component.html',
  styleUrls: ['./import-epu.component.css']
})
export class ImportEpuComponent implements OnInit {
  importEpuForm: FormGroup;

  constructor(private _formBuilder: FormBuilder,
              private _eventBusService: EventBusService,
              private _importerService: ImporterService,
              private _dialogRef: MatDialogRef<ImportEpuComponent>,
              @Optional() @Inject(MAT_DIALOG_DATA) private _data: ImportEpuDialogData) { }

  ngOnInit(): void {
    this._createForm();
  }

  importEpu() {
    const payload = this._createImportEpuPayload();
    const request = this._createImportEpuRequest(payload);
    return this._handleRequest(request);
  }

  get isCostReport() {
    return this._data?.costReport === true;
  }

  get title() {
    return this.isCostReport ? 'Raport kosztów EPU' : 'Import EPU';
  }

  get stepLabel() {
    return this.isCostReport ? 'Plik ze sprawami do raportu kosztów EPU' : 'Plik z sprawami EPU';
  }

  get formatDescription() {
    return this.isCostReport
      ? 'Nr. teczki sprawy dla której chcesz wyliczyć koszty EPU'
      : 'Nr. teczki sprawy którą chcesz wysłać do EPU';
  }

  get actionLabel() {
    return this.isCostReport ? 'Załaduj raport kosztów EPU' : 'Załaduj sprawy epu';
  }

  private _createForm() {
    this.importEpuForm = this._formBuilder.group({
      file: [null, Validators.required]
    })
  }

  get file() {
    return this.importEpuForm.get('file') as FormControl;
  }

  private _createImportEpuRequest(payload: IEpu) {
    const request = this.isCostReport
      ? this._importerService.importEpuCostReport(payload)
      : this._importerService.importEpu(payload);
    return request
      .pipe(
        tap(_ => this._eventBusService.display(DictionaryPosition.OK))
      )
  }

  private _createImportEpuPayload(): IEpu {
    return {
      file: this.importEpuForm.value.file
    } as IEpu
  }

  private _handleRequest(request: Observable<any>) {
    return request.subscribe(_ => this._dialogRef.close(true));
  }

}
